// Slide 1 - Intro Slide
export default function Slide1() {
  return (
    <div className="text-center max-w-6xl relative z-10 px-6">
      <div className="absolute -left-24 -top-10 opacity-40 pointer-events-none">
        <div
          style={{
            width: 380,
            height: 380,
            borderRadius: "50%",
            filter: "blur(80px)",
            background:
              "linear-gradient(135deg, rgba(99,102,241,0.28), rgba(236,72,153,0.12))",
          }}
        />
      </div>

      <div className="mb-8 inline-block">
        <div className="w-36 h-36 mx-auto bg-white/6 backdrop-blur-xl rounded-3xl border-2 border-white/20 flex items-center justify-center shadow-2xl transform transition-transform duration-700 hover:scale-105">
          <div className="bg-white rounded-xl p-2 shadow-sm">
            <img
              src="/slide1/sigma.png"
              alt="Sigma Solutions Logo"
              className="w-24 h-24 object-contain"
            />
          </div>
        </div>
      </div>

      <h1
        className="text-white font-extrabold leading-tight mb-4 drop-shadow-2xl"
        style={{
          fontSize: "clamp(44px, 8vw, 110px)",
          letterSpacing: "-0.03em",
        }}
      >
        Sigma Solutions
      </h1>

      <div className="mx-auto max-w-3xl">
        <p
          className="text-white/90 font-medium drop-shadow-lg mb-6"
          style={{ fontSize: "clamp(18px, 2.4vw, 26px)", lineHeight: 1.45 }}
        >
          We turn your <span className="keyword">vision</span> into{" "}
          <span className="keyword">scalable</span> digital products —
          design-led, engineering-driven, and built for growth.
        </p>

        {/* CTAs removed as requested */}

        <div className="flex items-center justify-center gap-6 flex-wrap">
          <div className="inline-flex items-center gap-3 text-white/90 bg-white/5 px-4 py-2 rounded-full">
            <span className="w-2 h-2 bg-emerald-400 rounded-full" />
            <span className="text-sm">Website Development</span>
          </div>
          <div className="inline-flex items-center gap-3 text-white/90 bg-white/5 px-4 py-2 rounded-full">
            <span className="w-2 h-2 bg-indigo-400 rounded-full" />
            <span className="text-sm">Product Development</span>
          </div>
          <div className="inline-flex items-center gap-3 text-white/90 bg-white/5 px-4 py-2 rounded-full">
            <span className="w-2 h-2 bg-sky-400 rounded-full" />
            <span className="text-sm">End-to-end</span>
          </div>
        </div>
      </div>
    </div>
  );
}
